export const normalizeFormText = (value) => String(value || '').trim();

export const appendFormText = (existing, incoming) => {
  const previous = normalizeFormText(existing);
  const next = normalizeFormText(incoming);
  if (!next) return previous;
  if (!previous) return next;
  return `${previous}\n${next}`;
};

export const normalizeAvatarText = normalizeFormText;
export const appendAvatarText = appendFormText;
